<template>
  <div v-if="experiments['experiment.ppTelcoCalculator'] === 'withCalculator'">
    <button
      class="group relative mt-12 w-full"
      @click="openModal(MODAL_NAMES.TELCO_CALCULATOR)"
    >
      <div
        class="absolute -top-12 left-24 border-x-12 border-b-12 border-solid border-x-transparent border-b-[#ECEEF2] group-hover:border-b-[#D9DAE0]"
      />
      <div
        class="bg-static-default-mid rounded-lg relative flex items-center gap-8 p-8 hover:bg-static-default-mid-hover"
      >
        <slot name="icons" />
        <div class="flex grow items-center justify-between">
          <div>
            <div class="body-2-bold -ml-6">{{ i18n(translations.title) }}</div>
            <div class="caption">{{ i18n(translations.subtitle) }}</div>
          </div>
          <IconChevronRight />
        </div>
      </div>
    </button>
    <TelcoCalculatorModal v-if="isUS" :price-telco :priceBM :savings>
      <template #configurator>
        <USTelcoCalculatorModalCalculator
          :price
          @price-changed="handlePriceChange"
        />
      </template>
    </TelcoCalculatorModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { Price } from '@backmarket/http-api'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '~/scopes/product/constants'
import USTelcoCalculatorModalCalculator from '~/scopes/product-core/pages/ProductDetailPage/us/components/USTelcoCalculatorModalCalculator/USTelcoCalculatorModalCalculator.vue'

import translations from './TelcoCalculatorAdvertisement.translations'
import TelcoCalculatorModal from './components/TelcoCalculatorModal/TelcoCalculatorModal.vue'

defineProps<{
  price: Price
}>()

const priceTelco = ref<number>(0)
const priceBM = ref<number>(0)
const savings = ref<number>(0)

const i18n = useI18n()
const experiments = useExperiments()
const marketplace = useMarketplace()

const isUS = computed(() => {
  return marketplace.market.countryCode === MarketCountryCode.US
})

function handlePriceChange(payload: {
  priceTelco: number
  priceBM: number
  savings: number
}) {
  priceTelco.value = payload.priceTelco
  priceBM.value = payload.priceBM
  savings.value = payload.savings
}
</script>
